import { render, staticRenderFns } from "./CheckOutForDraftOrderDetails.vue?vue&type=template&id=6bf4c7f4"
import script from "./CheckOutForDraftOrderDetails.vue?vue&type=script&lang=js"
export * from "./CheckOutForDraftOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./CheckOutForDraftOrderDetails.vue?vue&type=style&index=0&id=6bf4c7f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports